import { Redirect, Route, Switch } from 'react-router-dom';

import authRoutes from '../routes/authroutes.jsx';

function BlankLayout() {
  return (
    <Switch>
      {authRoutes.map((prop, key) =>
        prop.redirect ? (
          <Redirect from={prop.path} to={prop.pathTo} key={key} />
        ) : (
          <Route path={prop.path} component={prop.component} key={key} />
        )
      )}
    </Switch>
  );
}
export default BlankLayout;
